import { ClipboardCheck, Lightbulb, PenLine, MessagesSquare, Target, CheckCircle2 } from "lucide-react";

const steps = [
  { icon: ClipboardCheck, title: "Doen", text: "Opdrachten, testen, onderzoek en activiteiten.", example: "Interessetest afgerond" },
  { icon: Lightbulb, title: "Ontdekken", text: "Interesses, talenten, voorkeuren en mogelijkheden.", example: "Sterk in sociaal & onderzoekend" },
  { icon: PenLine, title: "Reflecteren", text: "Stilstaan bij resultaten en ervaringen.", example: "Reflectie op meeloopdag" },
  { icon: MessagesSquare, title: "Bespreken", text: "Inzichten meenemen naar mentor en ouders.", example: "Gesprek met mentor vastgelegd" },
  { icon: Target, title: "Kiezen", text: "Steeds beter onderbouwde keuzes maken.", example: "Profielkeuze onderbouwd" },
];

const StudentFlowSection = () => (
  <section id="zo-werkt-het" className="relative py-24 lg:py-32 animate-on-scroll scroll-mt-20 bg-gradient-to-b from-background via-accent/40 to-background">
    <div className="container mx-auto max-w-6xl px-4 sm:px-6">
      <div className="max-w-2xl mx-auto text-center mb-14">
        <span className="inline-block text-[11px] font-bold tracking-[0.2em] uppercase text-primary mb-4 px-3 py-1 bg-accent rounded-full">
          Zo werkt het voor de leerling
        </span>
        <h2 className="text-3xl lg:text-[2.6rem] font-extrabold text-secondary leading-tight [text-wrap:balance]">
          Van doen naar kiezen, in vijf herkenbare stappen.
        </h2>
        <p className="mt-4 text-lg text-muted-foreground">
          Elke stap wordt vastgelegd in het persoonlijke LOB-dossier.
        </p>
      </div>

      <ol className="grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {steps.map((s, i) => (
          <li key={s.title} className="relative rounded-3xl border border-border bg-card p-6 shadow-soft transition-all hover:-translate-y-1 hover:shadow-large">
            <div className="flex items-center justify-between mb-5">
              <div className="w-11 h-11 rounded-xl bg-primary/10 flex items-center justify-center">
                <s.icon className="w-5 h-5 text-primary" />
              </div>
              <span className="text-xs font-extrabold text-muted-foreground">0{i + 1}</span>
            </div>
            <h3 className="text-lg font-extrabold text-secondary">{s.title}</h3>
            <p className="mt-1 text-sm text-muted-foreground leading-relaxed">{s.text}</p>
            <div className="mt-5 flex items-center gap-2 rounded-xl bg-muted px-3 py-2 text-xs font-semibold text-secondary">
              <CheckCircle2 className="w-4 h-4 shrink-0 text-primary" />
              {s.example}
            </div>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default StudentFlowSection;
